import { ACTIONS, UI } from 'permission';

interface StepOption {
  label: string;
  key: string;
  permission?: [string, string];
}

export const STEPS_OPTIONS: StepOption[] = [
  { label: 'translation:job_header.steps', key: 'steps' },
  { label: 'translation:job_header.description', key: 'description' },
  { label: 'translation:job_header.openings', key: 'openings' },
  { label: 'translation:job_header.hired', key: 'hired' },
  {
    label: 'translation:job_header.promotion_requests',
    key: 'promotion-requests',
    permission: [ACTIONS.READ, UI.PROMOTION_REQUEST_VIEW],
  },
];
